// extracted by mini-css-extract-plugin
module.exports = {"SnackbarMessage":"Snackbar_SnackbarMessage__NePeh"};